import { IStoreState, ThunkDispatch } from '../../modules';
import { IconButton, InputAdornment, InputBase, Theme, Tooltip, WithStyles, createStyles, withStyles } from '@material-ui/core';
import React, { ChangeEvent, Component } from 'react';
import { Record, clearRecords, setViewerVisibility } from '../../modules/tracelog';
import { faChevronDown, faSearch, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { List } from 'immutable';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const styles = (theme: Theme) => createStyles({
  root: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'stretch',
  },
  searchBox: {
    width: '100%',
    border: 0,
    outline: 'none',
    flex: "1 1 auto ",
    padding: '0 0.5rem',
  },
  toolbarButtonRight: {
    borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 0
  },
  toolbarButtonLeft: {
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 0
  },
});

type State = {
  search: string
  sort: string
}

class ExchangesToolbar extends Component<Props, State> {
  state = {
    search: "",
    sort: "time",
  }

  handleClearExchanges = () => {
    this.props.clearRecords()
  }

  handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({
      search: e.target.value
    })

    _.debounce(() => this.props.fnSetFilterFn(this.createFilterFn()), 500)()
  }

  handleCloseViewer = () => {
    this.props.setViewerVisibility(false)
  }

  createFilterFn = (): ((e: List<Record>) => List<Record>) => {
    let search = this.state.search.toLowerCase()

    return (records: List<Record>) => {
      let terms = search.split(" ")

      return records.filter(r => {
        if (r.class === "soapexchange") {
          return [r.request, r.response].some(m =>
            m && terms.every(t => m.body.toLowerCase().includes(t))
          )
        }
        else if (r.class === "sdkaction") {
          return [r.method, r.arguments, r.module, r.platform, r.result].some(m =>
            m && terms.every(t => {
              if (typeof m === "object")
                return JSON.stringify(m).toLowerCase().includes(t)
              else
                return m.toString().toLowerCase().includes(t)
            })
          )
        }
        else
          return false
      })
    }
  }

  render = () => {
    const { classes } = this.props
    const { search } = this.state

    return (
      <div className={classes.root}>
        <Tooltip title="Minimize trace log viewer">
          <IconButton color="default" className={classes.toolbarButtonLeft} onClick={this.handleCloseViewer}>
            <FontAwesomeIcon icon={faChevronDown} fixedWidth size="sm" />
          </IconButton>
        </Tooltip>
        <InputBase
          placeholder="Enter a search term"
          className={classes.searchBox}
          startAdornment={<InputAdornment position="start" color="#999"><FontAwesomeIcon icon={faSearch} fixedWidth /></InputAdornment>}
          onChange={this.handleSearchChange}
          value={search}
        />
        <Tooltip title="Delete all trace logs">
          <IconButton color="default" className={classes.toolbarButtonRight} onClick={this.handleClearExchanges}>
            <FontAwesomeIcon icon={faTrashAlt} fixedWidth size="sm" />
          </IconButton>
        </Tooltip>
      </div>
    )
  }
}

const mapStateToProps = ({ intl }: IStoreState) => ({
  intl,
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      clearRecords,
      setViewerVisibility
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
  fnClear: () => void
  fnSetFilterFn: (filterFn: (record: List<Record>) => List<Record>) => void
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ExchangesToolbar))